var HouseItem = Vue.component('house-item', {
    props: ['house'],
    data: function(){
        return {
            fmts: {
                recommended: FmtMessage.getMessage('js.house.aerobilet.recommended'),
                totalPrice: FmtMessage.getMessage('js.resultForm.totalPrice.villa'),
                bedroom: FmtMessage.getMessage('js.house.bedroom'),
                bath: FmtMessage.getMessage('js.rhouse.bath'),
                maxPax: FmtMessage.getMessage('js.rhouse.max.pax'),
                minStay: FmtMessage.getMessage('js.rh.minstay'),
                beach: FmtMessage.getMessage('js.rhouse.beach'),
                airport: FmtMessage.getMessage('js.rhouse.airport'),
                market: FmtMessage.getMessage('js.rhouse.market'),
                night: FmtMessage.getMessage('js.rh.night'),
            },
            logo: '/images/logo/' + LOGO_DYNAMIC_NAME

        }
    },
    methods: {
        showDetail: function(data) {
            showHouseDetail(data);
        },
        formatPrice: function(value) {
            var val = (value/1).toFixed(0).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        getClass: function(p){
            var result= [];

            if(p.hasstop) {
                result.push('btn-hasstop');
            }
            else if(p.asksell){
                result.push('btn-asksell');
            }

            else{
                result.push('btn-primary');
            }
            return result;
        }
    },
    computed: {
        houseRowId: function () {
            return 'houseRowId_' + this.house.index;
        },
    },
    template: '\
        <div :id="houseRowId" class="item" :autocompleteid="house.autoCompleteId" :houseid="house.houseId" :pricekey = "house.housePriceKey" \
        :data-price="house.totalPrice" \
        :data-currency="house.currency"\
        :data-housename="house.houseName"\
        :data-petallowed="house.petAllowed"\
        :data-properties="house.properties"\
        :data-visible="true"\
        :data-recommended="house.recommended"\
        :data-lat="house.latitude"\
        :data-lon="house.longitude"\
        :data-index="house.index"\
        :data-asksell="house.asksell"\
        :data-includenotasksell="true"\
        :data-hasstop="house.hasstop">\
        \
            <div class="clearfix house-row"> \
                <div class="col-sm-3 col-xs-12 sr-photo">\
                    <a class="photoHover" @click="showDetail(house.index)">\
                        <img :src="house.imageUrl" alt="" class="hotel-thumb"/>\
                        <span v-if="house.recommended" class="recommend"><img :src="logo" alt="aerobilet"/>&nbsp;{{fmts.recommended}}</span>\
                    </a>\
                </div>\
                <div class="col-sm-6 col-xs-12">\
                    <div class="row">\
                        <div class="col-xs-12">\
                            <div class="hotelName">\
                                <a title="" @click="showDetail(house.index)"><span class="hotel-name-text">{{house.houseName}}</span></a>\
                                <h4 class="hotel-location"><span class="resultRoomName"> {{house.city}} , {{house.district}}</span></h4>\
                            </div>\
                        </div>\
                        <div class="col-xs-12 house-description">\
                            <div class="house-description-text">\
                                <p v-if="house.houseDescription">{{house.houseDescription}}</p>\
                            </div>\
                        </div>\
                    </div>\
                </div>\
                <div class="col-sm-3 col-xs-12 sr-houseprice">\
                    <div class="contunie">\
                        <button type="button" title="" @click="showDetail(house.index)" class="btn btn-block" :class="getClass(house)">\
                            {{ formatPrice(house.dailyPrice) }} &nbsp;{{house.currency}}\
                        </button>\
                        <input :id="\'dailyPrice_\'+house.index" :value="house.dailyPrice" type="hidden"/>\
                    </div>\
                    <label class="sr-totalpricetext">{{fmts.totalPrice}}</label>\
                </div>\
                <div class="col-sm-offset-3 col-sm-9 col-xs-12 house-description">\
                    <div class="sr-houseProp prop-icon-wrapper">\
                        <div class="prop-icons prop-icon-item"><i class="fas fa-bed" aria-hidden="true"></i><label>{{house.bedroomCount}} {{fmts.bedroom}}</label></div>\
                        <div class="prop-icons prop-icon-item"><i class="fas fa-shower" aria-hidden="true"></i><label>{{house.bathroomCount}} {{fmts.bath}}</label></div>\
                        <div class="prop-icons prop-icon-item"><i class="fas fa-user" aria-hidden="true"></i><label>{{house.maxPax}} {{fmts.maxPax}}</label></div>\
                        <div v-if="house.minStay > 0" class="prop-icons prop-icon-item">\
                            <span class="info-icon titleTip" :title="fmts.minStay"><i class="fas fa-exclamation-circle" aria-hidden="true"></i><label>{{house.minStay}} {{fmts.night}}</label></span>\
                        </div>\
                    <div class="prop-icons prop-icon-item">\
                        <span class="info-icon titleTip" :title="fmts.market"><i class="fas fa-shopping-cart" aria-hidden="true"></i><label>{{house.marketDistance}} km</label></span>\
                    </div>\
                    <div class="prop-icons prop-icon-item">\
                        <span class="info-icon titleTip" :title="fmts.beach" /><i class="fas fa-swimmer" aria-hidden="true"></i><label>{{house.seaDistance}} km</label></span>\
                    </div>\
                    <div class="prop-icons prop-icon-item">\
                        <span class="info-icon titleTip " :title="fmts.airport" ><i class="fas fa-plane" aria-hidden="true"></i><label>{{house.airportDistance}} km</label></span>\
                    </div>\
                </div>\
                </div>\
            </div>\
        </div>'
});